import { Spin } from 'antd';

import styles from '@styles/modules/components/LoadingState.module.scss';

export interface LoadingStateProps {
  label?: string;
}

const LoadingState = ({ label = 'Loading...' }: LoadingStateProps) => (
  <div className={styles.wrapper} role="status" aria-live="polite">
    <Spin size="large" />
    <span>{label}</span>
  </div>
);

export default LoadingState;
